import { render, staticRenderFns } from "./LoggedUserMenu.vue?vue&type=template&id=174123c8&scoped=true"
import script from "./LoggedUserMenu.vue?vue&type=script&lang=ts"
export * from "./LoggedUserMenu.vue?vue&type=script&lang=ts"
import style0 from "./LoggedUserMenu.vue?vue&type=style&index=0&id=174123c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174123c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VImg,VMenu})
